import React from "react";
import { TextField } from "@material-ui/core";
import ComboBoxWithCreate from "./ComboBoxWithCreate";

export default function FancyComboBoxWithCreate({ label, name, value, options, onChange, disabled }) {
	value = value || [];

	const InputComponent = React.forwardRef(function InputComponent(props, ref) {
		return (
			<ComboBoxWithCreate
				{...props}
				ref={ref}
				inputRef={props.inputRef}
				name={name}
				onChange={onChange}
				value={(value || []).map((x) => ({ label: x, value: x }))}
				options={(options || []).map((x) => ({ label: x, value: x }))}
				isClearable={false}
				isMulti
				isSearchable
				closeMenuOnSelect={false}
				backspaceRemovesValue
				disabled={disabled}
			/>
		);
	});

	return (
		<TextField
			fullWidth
			multiline
			label={label}
			InputLabelProps={{ shrink: true }}
			InputProps={{
				inputComponent: InputComponent
			}}
			margin="normal"
			variant="outlined"
			disabled={disabled}
		/>
	);
}
